import { useEffect, useState } from "react";
import { bool } from "prop-types";
import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";
import { useEstimateEditorStore } from "@tools";
import { useEditorWebsocket } from "@hooks";
import { Button } from "@components";
import { CircularProgress, Grid, Paper } from "@material-ui/core";
import useStyle from "./AgentSessionBar.style";

/**
 * Shown while an MCP agent edits the project. A user who may edit can take the editing back;
 * the agent's further writes are then refused until the user closes the editor.
 */
export const AgentSessionBar = observer(({ canTakeOver }) => {
  const { t } = useTranslation();
  const classes = useStyle();
  const socket = useEditorWebsocket();
  const { agentSession } = useEstimateEditorStore();
  const [isTakingOver, setTakingOver] = useState(false);
  
  // the server answers with the end of the session, or sends its state again
  useEffect(() => {
    setTakingOver(false);
  }, [agentSession]);
  
  if(!agentSession)
    return null;
  
  const handleTakeover = () => {
    if(isTakingOver)
      return;
    setTakingOver(true);
    socket.requestAgentSessionTakeover();
  };
  
  return (
    <Paper
      elevation={6}
      className={classes.root}
    >
      <Grid
        container
        role="status"
        alignItems="center"
        wrap="nowrap"
      >
        <CircularProgress aria-label="progress indicator" size={24} className="mr-3" />
        <h3>
          {
            agentSession.actorName
              ? t("alerts.editor.agent_session.working_for", { name: agentSession.actorName })
              : t("alerts.editor.agent_session.working")
          }
        </h3>
        {
          canTakeOver &&
          <Button className="ml-4" onClick={handleTakeover} disabled={isTakingOver}>
            {t("alerts.editor.agent_session.take_over")}
          </Button>
        }
      </Grid>
    </Paper>
    );
});

AgentSessionBar.propTypes = {
  canTakeOver: bool,
};
